import classnames from 'classnames';
import React__default, { memo, useState, useCallback, useEffect } from 'react';
import { useProgress } from './hooks/use_progress.js';
import { kinds, autoClosePeriod } from './toast_provider.js';
import '../button/index.js';
import { Icon } from '../icons/index.js';
import '../localization/index.js';
import { visibility, toastContainer, innerToastContainer, toastContentContainer, toastButtonsContainer, progressLine } from './style.css.js';
import { useLocalization } from '../localization/localization.js';
import { Button } from '../button/button.js';

const Toast = memo(function Toast(props) {
    const { action, content, kind = kinds.info.kind, autoClose = 'long', onClose, hovered } = props;
    const closeLabel = useLocalization('close');
    const progressLineLabel = useLocalization('progressLine');
    const [visible, setVisible] = useState(true);
    const { percentage, setPause } = useProgress(autoClosePeriod[autoClose]);
    const closeAfterTimeout = useCallback((timeout) => {
        if (!onClose)
            return;
        setTimeout(() => onClose(), timeout);
    }, [onClose]);
    const handleClose = useCallback(() => {
        setVisible(false);
        closeAfterTimeout(300);
    }, [closeAfterTimeout]);
    const handleAction = useCallback(async (action) => {
        if (!action)
            return;
        const close = await action.onClick();
        if (close) {
            handleClose();
        }
    }, [handleClose]);
    useEffect(() => {
        setPause(!hovered);
    }, [hovered, setPause]);
    useEffect(() => {
        if (percentage >= 100) {
            handleClose();
        }
    }, [percentage, handleClose]);
    return (React__default.createElement("div", { role: "status", "aria-label": `${kind} message`, className: classnames(visible ? visibility.visible : visibility.hidden, toastContainer) },
        React__default.createElement("div", { className: classnames(innerToastContainer) },
            React__default.createElement("div", { className: toastContentContainer },
                React__default.createElement(Icon, { kind: kinds[kind].kind, name: kinds[kind].icon }),
                React__default.createElement("div", null, content)),
            React__default.createElement("div", { className: toastButtonsContainer },
                action && visible && (React__default.createElement(Button, { size: "small", kind: "ghost", onClick: () => handleAction(action) }, action.title)),
                React__default.createElement(Button, { size: "small", iconStart: "small-cross", hideLabel: true, kind: "ghost", "aria-label": closeLabel, onClick: handleClose }, closeLabel))),
        autoClose !== 'off' && (
        // Need to add calculation with -8px to help centering the line.
        React__default.createElement("div", { "aria-label": progressLineLabel, className: progressLine, style: { width: `calc(${percentage}% - 8px)` } }, ''))));
}, compareProps);
function compareProps(prev, next) {
    if (prev.hovered !== next.hovered)
        return false;
    if (prev.id === next.id)
        return true;
    return false;
}

export { Toast as default };
